import {
  sha512
} from "js-sha512";
import store from "./store";

export default {
  data: function () {
    return {
      colors: [
        'danger', 'success', 'warning'
      ],
      status: ['pending', 'processing', 'sending', 'completed'],
      orderstatus: {
        0: {
          name: 'pending',
          color: '#44eeee'
        },
        1: {
          name: 'processing',
          color: '#1eee266'
        },
        2: {
          name: 'sending',
          color: '#dddd55'
        },
        3: {
          name: 'completed',
          color: '#44ee44'
        }
      },
    };
  },
  methods: {
    t(words) {
      var lang = store.get('lang');
      return words[lang] ? words[lang] : words[0];
    },
    match(s, t) {
      try {
        if (!t) return true;
        return t && ("" + t).toLowerCase().indexOf(("" + s).toLowerCase()) >= 0;
      } catch (e) {
        return true;
      }
    },
    hash(s) {
      var hash = sha512.create();
      hash.update("" + s);
      return hash.hex();
    },
    swalsuccess() {
      return {
        title: 'Success',
        type: "success",
        allowOutsideClick: false
      };
    },
    swalconfirm() {
      return {
        text: "Are you sure?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: false
      };
    }
  },
  filters: {
    numberformat(value) {
      if (!value) return 0;
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    datetime(seconds) {
      const iso = new Date(seconds * 1000).toISOString();
      return iso.split(".")[0].replace("T", " ");
    }
  }
};
